/**
 * Los canales de configuración, agrupados por línea de negocio.
 *
 * La agrupación no es cosmética: **un canal pertenece a una línea y no se usa
 * en la otra**. Kapso es el WhatsApp de AR y Maytapi el de recobro; no hay
 * respaldo entre ellos. Una pantalla que los enseñara en una lista plana
 * invitaría justo al error contrario.
 *
 * Los canales sin construir aparecen igualmente, apagados: la simetría entre
 * las dos líneas es la información: se ve de un vistazo qué le falta a AR.
 */
export const LINEAS = [
  {
    id: 'ar',
    nombre: 'Gestión propia',
    canales: [
      { id: 'kapso', nombre: 'WhatsApp', proveedor: 'Kapso' },
      { id: 'resend', nombre: 'Email', proveedor: 'Resend' },
      { id: 'ar-calls', nombre: 'Llamadas', proveedor: 'Telnyx' },
    ],
  },
  {
    id: 'recobro',
    nombre: 'Recobro',
    canales: [
      // Las claves de recobro son las de siempre: la URL `?tab=maytapi` ya
      // circula por ahí y no cuesta nada seguir respetándola.
      //
      // El proveedor son DOS desde que el motor de WhatsApp vive dentro del
      // producto: la API de Maytapi y las líneas que salen por un Chrome real
      // en el portátil. No son intercambiables —la segunda no tiene API, sus
      // envíos son asíncronos y su modelo de volumen es otro— y el reparto
      // entre las dos lo hace el despachador.
      { id: 'maytapi', nombre: 'WhatsApp', proveedor: 'Maytapi y navegador' },
      { id: 'gmail', nombre: 'Email', proveedor: 'Gmail' },
      { id: 'aircall', nombre: 'Llamadas', proveedor: 'Aircall' },
      // El primer contacto de recobro (`new_sms`) y, desde el 09/10/2026, sus
      // respuestas. AR no usa SMS.
      { id: 'sms', nombre: 'SMS', proveedor: 'BulkGate' },
    ],
  },
];

const TODOS = LINEAS.flatMap(l => l.canales);

/** Los que se pueden abrir hoy. Un `?tab=` de un canal pendiente no vale. */
export const esCanalValido = id => TODOS.some(c => c.id === id && !c.pendiente);

export const CANAL_POR_DEFECTO = 'kapso';
